module.exports = __webpack_public_path__ + "static/Dananjay.c6860093.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Dananjay.jpg
// module id = 1294
// module chunks = 137408898365125